angular.module("events")

    .controller("cmsCategoriesEventsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'uiGridTreeViewConstants', 'gridService', 'treeService', 'modalService', '$uibModal', '$filter', '$translate', '$state', '$stateParams', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, uiGridTreeViewConstants, gridService, treeService, modalService, $uibModal, $filter, $translate, $state, $stateParams, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("CMS_CATEGORIES_WRITE");

            $scope.id = $stateParams.id
            logService.debug($scope.id)

            $rootScope.title = $filter('translate')('cms_categories.title');


            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                { title: $filter('translate')('cms_categories.title') }
            ];



            logService.debug($stateParams);
            $scope.gridOptions = {
                pdfTitle: $filter('translate')('cms_categories.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                enableSorting: true,
                expandAllRows: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [15, 30, 45],
                paginationPageSize: 15,
                // rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },

                columnDefs: [
                    { name: 'id', visible: false, exporterSuppressExport: true },
                    {
                        name: 'icon', displayName: $filter('translate')('cms.icon'), cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<i class="fas fa-{{row.entity.icon}} text-primary m-l-sm" ></i>' +
                            '</div>', width: 80, enableFiltering: false, enableHiding: false
                    },

                    { name: 'name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.edit'), action: 'ui-sref="events.edit.cms_categories-edit({category_id: row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    var deferred = $q.defer();

                    Restangular.all('CmsCategories').getList({ options, event_id: $scope.id }).then(function (result) {

                        $scope.allCmsCategories = result;

                        result.unshift({
                            id: null,
                            name: null
                        });
                        var treeCmsCategories = [];
                        var data = treeService.cmsCategoriesTree(result, null, treeCmsCategories);

                        deferred.resolve(data);
                    });
                    return deferred.promise;
                }

            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("events.edit.cms_categories-edit", { cms_categories_id: rowEntity.cms_categories_id, category_id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;

                let hijos = false;
                $scope.allCmsCategories.forEach(category => {
                    if (category.parent_cms_category_id == id) { hijos = true };
                });

                if (hijos) {
                    modalService.message({
                        title: $filter('translate')('cms_categories.delete_message_children_title'),
                        message: $filter('translate')('cms_categories.delete_message_children_error'),
                        onAccept: function () { }
                    });
                } else {
                    modalService.confirm({
                        title: $filter('translate')('cms_categories.delete'),
                        message: $filter('translate')('cms_categories.delete_message') + " " + $scope.name + "?",
                        onAccept: function () {
                            Restangular.one('CmsCategories', $scope.id).remove().then(function () {
                                toastr.success($filter('translate')('cms_categories.remove_success'));
                                $scope.gridOptions.data = $scope.allCmsCategories =
                                    $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                            }, function (response) {
                                logService.error("Error with status code", response.status);
                            });
                        }
                    });
                };
            };

        }]);